/**
 * @TODO - DELETE IT WHEN INTEGRATION WITH TMS IS READY, IT'S TEMP IMPLEMENTATION TO UNBLOCK UNHAPPY CLIENTS
 */

import { CompanyService, UserService, User } from '../types';

export type TenantInfo = {
  tid: string;
  name: string;
  parent_tid?: string | null;
  is_home: boolean;
  is_current: boolean;
  canary: boolean;
  state: string;
  platform_version: string;
};

export type TenantSwitchResponse = {
  tid: string;
  name: string;
  parent_tid?: string | null;
  message: string;
};

export class LegacyTenancyService {
  static async listTenancies(user: User): Promise<TenantInfo[]> {
    const companies = await CompanyService.getCompaniesList({
      isAllowCsAccess: true
    });

    const originCompanyId = user.originCompanyId;
    const currentCompanyId = user.companyId;

    // Map companies to TenantInfo format
    return companies.map((company) => ({
      tid: String(company.id),
      name: company.name || '',
      parent_tid: originCompanyId && company.id !== originCompanyId ? String(originCompanyId) : null,
      is_home: company.id === originCompanyId,
      is_current: company.id === currentCompanyId,
      canary: false, // Not supported yet
      state: 'active',
      platform_version: '2.1.0' // Not available from API yet
    }));
  }

  static async switchTenancy({ tenantId, user }: { tenantId: string; user: User }): Promise<TenantSwitchResponse> {
    const targetCompanyId = Number(tenantId);

    // Call the updateUserCompany API
    await UserService.updateUserCompany({
      id: user.id!,
      requestBody: {
        targetCompanyId
      }
    });

    return {
      tid: tenantId,
      name: '',
      parent_tid: user.originCompanyId ? String(user.originCompanyId) : null,
      message: '',
    };
  }

  static async resetTenancy(user: User): Promise<TenantSwitchResponse> {
    const originCompanyId = user.originCompanyId;

    if (!originCompanyId) {
      throw new Error('Home tenant not found');
    }

    // Switch to origin company
    await UserService.updateUserCompany({
      id: user.id!,
      requestBody: {
        targetCompanyId: originCompanyId
      }
    });

    return {
      tid: String(originCompanyId),
      name: '',
      parent_tid: null,
      message: '',
    };
  }
}
